import React from 'react';
import PropTypes from 'prop-types';
import { Gear } from '@picsio/icons';
import { Icon, IconButton } from '@picsio/ui';
import Tooltip from '../Tooltip';
import localization from '../../shared/strings';
import isColorLabelSettingsAvailable from './isColorLabelSettingsAvailable';
import useOpenColorLabelSettings from './useOpenColorLabelSettings';

const l10n = localization.CATALOG_ITEM.colorLabels;

export default function ColorLabelSettingsButton({
  loggerEvent,
  className,
  size = 'md',
  placement = 'left',
}) {
  const openSettings = useOpenColorLabelSettings(loggerEvent);

  if (!isColorLabelSettingsAvailable()) return null;

  return (
    <Tooltip content={l10n.manageTooltip} placement={placement}>
      <IconButton
        className={className}
        size={size}
        componentProps={{ 'aria-label': l10n.manageTooltip }}
        onClick={(event) => {
          event.stopPropagation();
          openSettings();
        }}
      >
        <Icon size={size}><Gear /></Icon>
      </IconButton>
    </Tooltip>
  );
}

ColorLabelSettingsButton.propTypes = {
  loggerEvent: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  placement: PropTypes.string,
};
